'use client';

import { EducationalPost } from '@insta-club/models';
import { CustomVideo, ReelsDescription } from '@insta-club/ui';
import { cn } from '@insta-club/utilities';
import Image from 'next/image';
import { memo, useState } from 'react';

const EducationalPostVideo: React.FC<{
    item: EducationalPost;
    onTimeupdateDelay?: (time: number) => void;
    onBack?: () => void;
}> = ({ item, onTimeupdateDelay, onBack }) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className='relative h-full w-full cursor-pointer bg-black'>
            <div
                onClick={() => setExpanded(false)}
                className={cn('absolute inset-x-0 bottom-0 z-30 bg-gradient-to-t from-black to-transparent', {
                    'pointer-events-auto top-0': expanded,
                    'pointer-events-none h-1/3': !expanded
                })}
            />

            <MemoizedEducationalPostVideoContent item={item} onTimeupdateDelay={onTimeupdateDelay} onBack={onBack} />

            <div className='absolute inset-x-0 bottom-8 z-50 flex flex-col gap-2 px-4 text-white'>
                <div className='flex items-center gap-3'>
                    <Image
                        className='ml-1 h-9 w-9 rounded-full border-2 border-gray-400 object-cover'
                        width={36}
                        height={36}
                        src={item.user.image ?? '/img-not-found-placeholder.jpg'}
                        alt={'educational-mentor-image'}
                        loading='lazy'
                    />
                    <span>
                        {item.user.first_name} {item.user.last_name}
                    </span>
                </div>
                {item.title ? (
                    <ReelsDescription text={item.description} isExpanded={expanded} onExpanded={setExpanded} />
                ) : null}
            </div>
        </div>
    );
};

export default EducationalPostVideo;

interface VideoContentProps {
    item: EducationalPost;
    onTimeupdateDelay?: (time: number) => void;
    onBack?: () => void;
}

const EducationalPostVideoContent: React.FC<VideoContentProps> = ({ item, onTimeupdateDelay, onBack }) => {
    if (item.url) {
        return (
            <CustomVideo
                hlsUrl={item.hls}
                mp4Url={item.url}
                disableProgress={false}
                showProgress
                onTimeupdateDelay={onTimeupdateDelay}
                onBack={onBack}
            />
        );
    }

    return null;
};

const MemoizedEducationalPostVideoContent = memo(EducationalPostVideoContent);

